import eventBus from "../../../../main";
import apiServices from "../../../../../services/apiServices";

export default {
  state: {
    localETransactions: {
      ownTransaction: []
    }
  },
  mutations: {
    SET_ALL_E_TRANSACTIONS(state, value) {
      state.localETransactions.ownTransaction = value;
    }
  },
  actions: {
    displayAllETransaction(context, payload) {
      apiServices
        .getETransactions(payload)
        .then(function(response) {
          if (response.status === 200 || response.status === 300) {
            let obj = response.data;
            context.commit("SET_ALL_E_TRANSACTIONS", obj.message);
          } else {
            let payload = {
              color: "info",
              text: "Não há dados disponíveis",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center",
            top: "top"
          };
          if (error == "Error: Network Error") {
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center",
              top: "top"
            }); // emit the event to the bus
          }
          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    }
  },
  getters: {
    getAllETransactions(state) {
      return state.localETransactions.ownTransaction;
    }
  }
};
